"use client";

/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-10-08 11:50:39
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-10-22 15:37:31
 * @FilePath: src/hooks/use-citron.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
function useCitron() {
  const $ = _c(6);
  const [isMapAccepted, setIsMapAccepted] = useState(false);
  const [isAnalyticsAccepted, setIsAnalyticsAccepted] = useState(false);
  const [cookies] = useCookies();
  let t0;
  let t1;
  if ($[0] !== cookies) {
    t0 = () => {
      if (!cookies) {
        return;
      }
      const cookie = cookies?.tarteaucitron;
      if (cookie) {
        const googleMapsAccepted = cookie.split("!").find(_temp)?.includes("true") || false;
        const analyticsAccepted = cookie.split("!").find(_temp2)?.includes("true") || false;
        setIsMapAccepted(googleMapsAccepted);
        setIsAnalyticsAccepted(analyticsAccepted);
      }
    };
    t1 = [cookies];
    $[0] = cookies;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isAnalyticsAccepted || $[4] !== isMapAccepted) {
    t2 = {
      isMapAccepted,
      isAnalyticsAccepted
    };
    $[3] = isAnalyticsAccepted;
    $[4] = isMapAccepted;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp2(part_0) {
  return part_0.includes("gtag");
}
function _temp(part) {
  return part.includes("googlemaps");
}
export default useCitron;